import {lineString as lineStringFN} from "@turf/helpers";

export default function turfPoint(coordinates, properties, options) {
    return lineStringFN(coordinates, properties, options);
}
